import { Component, Version } from '@angular/core';

declare var __VERSION__: string;


@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
})

export class FooterComponent {

    VersionNumber = '1.17.2019.8';

    public dateNow: any = Date.now();

    constructor() {
    }

}
